// extracted by mini-css-extract-plugin
module.exports = {"contentFooter":"PageContentFooter-contentFooter-3ODMj"};